var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26651_38558",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0.5H0.5V22.5H37.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26651_38558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0324 2.83203H13.9688V20.1435H24.0324V2.83203Z",
    fill: "#F15C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7176 11.4894C14.7176 7.92527 16.4948 4.89151 19 2.83366C17.0729 1.32739 14.5677 0.5 11.8912 0.5C5.68171 0.5 0.5 5.44311 0.5 11.4894C0.5 17.5357 5.68171 22.4788 11.8912 22.4788C14.5463 22.4788 17.0729 21.6514 19 20.1451C16.3449 18.0873 14.7176 15.0747 14.7176 11.4894Z",
    fill: "#EA1D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 11.4894C37.5 17.5357 32.3183 22.4788 26.1088 22.4788C23.4537 22.4788 20.9271 21.6514 19 20.1451C21.6551 18.0873 23.2824 15.0535 23.2824 11.4894C23.2824 7.92527 21.5052 4.89151 19 2.83366C20.9271 1.32739 23.4323 0.5 26.1088 0.5C32.3183 0.5 37.5 5.44311 37.5 11.4894Z",
    fill: "#F69E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.57d7e83d33bebb3dccf6c6465488d543.svg";
export { ForwardRef as ReactComponent };